import React from 'react';
import PropTypes from 'prop-types';

import connect from 'components/lib/connect';
import ExternalCustomerLookup from './external_customer_lookup/external_customer_lookup';
import PageLayout from './page_layout';

export function ExternalCustomerLookupPage({ customerId }) {
  return (
    <PageLayout id="external-customer-lookup-page">
      <ExternalCustomerLookup customerId={customerId} />
    </PageLayout>
  );
}

ExternalCustomerLookupPage.propTypes = {
  customerId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(ExternalCustomerLookupPage);

function mapStateToProps({ getProvider }) {
  return {
    customerId: getProvider('currentLocation').get().customerId,
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/external_customer_lookup_page.jsx